// extracted by mini-css-extract-plugin
module.exports = {"videoPlayer":"videoPlayer-module--videoPlayer--3rfrt","videoPlayerAudio":"videoPlayer-module--videoPlayerAudio--2Ce4C"};